export default "__VITE_ASSET__sg5TCep6__"